import client from "./client";

const capCard = (card = {}) => ({
  icon: card.icon || "",
  title: card.title || "",
  description: card.description || "",
});

const statCard = (card = {}) => ({
  number: card.number || "",
  label: card.label || "",
});

const workCard = (card = {}) => ({
  n: card.n || "",
  title: card.title || "",
  description: card.description || "",
});

const TEXT_KEYS = [
  "heroBadge",
  "heroTitle",
  "heroBody",
  "heroVideoCaption",
  "heroPlayLabel",
  "heroPrimaryCtaText",
  "heroPrimaryCtaLink",
  "heroSecondaryCtaText",
  "heroSecondaryCtaLink",
  "heroImage",
  "capBadge",
  "capTitleLead",
  "capTitleAccent",
  "capBody",
  "compBadge",
  "compTitleLead",
  "compTitleAccent",
  "compBody",
  "compImage",
  "workTitleLead",
  "workTitleAccent",
  "workCtaText",
  "workCtaLink",
  "demoBadge",
  "demoTitleLead",
  "demoTitleAccent",
  "demoBody",
  "demoCtaText",
  "demoCtaLink",
];

const BOOL_KEYS = ["heroHide", "capHide", "compHide", "workHide", "demoHide"];
const CAP_KEYS = ["cap1", "cap2", "cap3", "cap4"];
const STAT_KEYS = ["stat1", "stat2"];
const WORK_KEYS = ["work1", "work2", "work3", "work4", "work5", "work6"];

export function prepareProductPage(form = {}) {
  const payload = {};

  TEXT_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = form[key] ?? "";
  });
  BOOL_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = !!form[key];
  });

  CAP_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = capCard(form[key]);
  });
  STAT_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = statCard(form[key]);
  });
  WORK_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = workCard(form[key]);
  });

  return payload;
}

export const getProductPage = () => client.post("/productpage/getPage");
export const addProductPage = (payload) =>
  client.post("/productpage/addpage", payload);
export const updateProductPage = (payload) =>
  client.post("/productpage/updatePage", payload);
